import React, { useState } from "react";
import { Label } from "../../../../../../stories/Label/Label";
import Input from "../../../../../../stories/Input/Input";
import PhoneInput from "react-phone-input-2";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../../../utils/Enum.keys";
import { handleMUISelectEvent } from "../../../../../../utils/UtilFunctions";
import { TextField } from "@mui/material";
import { Button } from "../../../../../../stories/Button/Button";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const UserDetails = ({ setModalFlag }: Props) => {
  const [edit,setEdit]= useState(false);
  return (
    <>
      {/* use this div for form */}
      <div className="subsidary__view--form--company-details">
        <div className="subsidary__add--form-details">
          <div className="company-details__block--left">
            <div className="company-details__block--details">
              <h4>User Details</h4>
            </div>
            <div className="label-grid">
              <>
                <Label>User Name</Label>
                <Input disabled={!edit}/>
              </>
              <>
                <Label>Designation</Label>
                <Input disabled={!edit}/>
              </>
              <>
                <Label>Mobile No.</Label>
                <PhoneInput
                  country={"in"}
                  disabled={!edit}
                  // value={formData.std_guardian_mobile}
                  // onChange={(newMobile) => {
                  //   setFormData((prevValues) => ({
                  //     ...prevValues,
                  //     std_guardian_mobile: newMobile,
                  //   }));
                  // }}
                  // onKeyDown={(e) => {
                  //   if (e.key === Keys.ENTER) {
                  //     e.preventDefault();
                  //     dobRef.current?.focus();
                  //   }
                  // }}
                />
              </>

              <>
                <Label>Email</Label>
                <Input disabled={!edit}/>
              </>
              <>
                <Label>Aadhar</Label>
                <Input disabled={!edit}/>
              </>
              <>
                <Label>Address</Label>
                <TextArea rows={3} disabled={!edit}/>
              </>

              <>
                <Label>Pin Code</Label>
                <Input disabled={!edit}/>{" "}
              </>
              <>
                <Label>Department</Label>

                <FormAutocomplete
                  className={formClasses.inputRoot}
                  // options={States!}
                  options={["India", "NewZealand"]}
                  // ref={stateRef!}
                  onKeyDown={(e) => {
                    if (e.key === Keys.ENTER) {
                      e.preventDefault();
                      handleMUISelectEvent(e);
                    }
                    // if (e.key === Keys.BACKSPACE) {
                    //   setFormData((prevValues) => {
                    //     return {
                    //       ...prevValues,
                    //       cust_state: EMPTY_STRING,
                    //     };
                    //   });
                    // }
                  }}
                  // value={
                  //   States?.find(
                  //     ({ value }) => value === formData.cust_state
                  //   )! ?? null
                  // }
                  // onChange={(e, newValue) => {
                  //   if (newValue) {
                  //     setFormData((prevValues) => {
                  //       return {
                  //         ...prevValues,
                  //         cust_state: (newValue as optionsType)
                  //           ?.value,
                  //       };
                  //     });
                  //   } else {
                  //     setFormData((prevValues) => {
                  //       return {
                  //         ...prevValues,
                  //         cust_state: EMPTY_STRING,
                  //       };
                  //     });
                  //   }
                  // }}
                  openOnFocus
                  forcePopupIcon
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // onChange={(e) => {
                      //   setFormData((prevValues) => {
                      //     return {
                      //       ...prevValues,
                      //       cust_state: e.target.value!,
                      //     };
                      //   });
                      // }}
                      fullWidth
                      className={formClasses.formControlRoot}
                    />
                  )}disabled={!edit}
                />
              </>
              <>
                <Label>Rights</Label>

                <FormAutocomplete
                  className={formClasses.inputRoot}
                  // options={States!}
                  options={["India", "NewZealand"]}
                  // ref={stateRef!}
                  onKeyDown={(e) => {
                    if (e.key === Keys.ENTER) {
                      e.preventDefault();
                      handleMUISelectEvent(e);
                    }
                    // if (e.key === Keys.BACKSPACE) {
                    //   setFormData((prevValues) => {
                    //     return {
                    //       ...prevValues,
                    //       cust_state: EMPTY_STRING,
                    //     };
                    //   });
                    // }
                  }}
                  // value={
                  //   States?.find(
                  //     ({ value }) => value === formData.cust_state
                  //   )! ?? null
                  // }
                  // onChange={(e, newValue) => {
                  //   if (newValue) {
                  //     setFormData((prevValues) => {
                  //       return {
                  //         ...prevValues,
                  //         cust_state: (newValue as optionsType)
                  //           ?.value,
                  //       };
                  //     });
                  //   } else {
                  //     setFormData((prevValues) => {
                  //       return {
                  //         ...prevValues,
                  //         cust_state: EMPTY_STRING,
                  //       };
                  //     });
                  //   }
                  // }}
                  openOnFocus
                  forcePopupIcon
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // onChange={(e) => {
                      //   setFormData((prevValues) => {
                      //     return {
                      //       ...prevValues,
                      //       cust_state: e.target.value!,
                      //     };
                      //   });
                      // }}
                      fullWidth
                      className={formClasses.formControlRoot}
                    />
                  )}disabled={!edit}
                />
              </>
            </div>
          </div>
        </div>
        {!edit ? (
                <Button
                  mode="edit"
                  type="button"
                  onClick={() => setEdit(true)}
                />
              ) : (
                <Button mode="save" type="submit" />
              )}        <Button mode="clear" />
        <Button mode="cancel" onClick={()=>setModalFlag(false)}/>
      </div>
    </>
  );
};

export default UserDetails;
